/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {grantConsent} from '../api'

export const useMutationGrantConsent = createReactQueryMutationHook('grantConsent', grantConsent)
